import { BaseEnum } from "../BaseEnum";

export class BusinessPlanStatus extends BaseEnum {
  static PENDING = 1;
  static SUBMITTED = 2;

  static Codes = [this.PENDING, this.SUBMITTED];
  static _labelKeys = ["pending", "submitted"];
}
